import type { QueryClient } from 'react-query'
import { GET_EVENT_LIST_CACHE_KEY } from 'src/modules/event/hooks/use-event-list'
import { GET_NOT_SENT_REMINDERS_COUNT_CACHE_KEY } from 'src/modules/event/hooks/use-not-sent-reminders-count'
import { GET_INVOICES_CACHE_KEY } from 'src/modules/payment/hooks/use-invoices'
import { GET_SUBSCRIPTION_CACHE_KEY } from 'src/modules/payment/hooks/use-subscription'
import { GET_SUBSCRIPTION_PLANS_CACHE_KEY } from 'src/modules/payment/hooks/use-subscription-plans'
import { GET_PROFILE_CACHE_KEY } from 'src/modules/user/hooks/use-profile'

/** Refetches every query whose answer changes when the account starts or resumes paying. */
export function invalidateBillingQueries(queryClient: QueryClient): void {
  const keys = [
    GET_PROFILE_CACHE_KEY,
    GET_SUBSCRIPTION_CACHE_KEY,
    GET_SUBSCRIPTION_PLANS_CACHE_KEY,
    GET_INVOICES_CACHE_KEY,
    GET_NOT_SENT_REMINDERS_COUNT_CACHE_KEY,
    GET_EVENT_LIST_CACHE_KEY,
  ]

  keys.forEach((key) => queryClient.invalidateQueries(key))
}
